<template>
    <div>
        <h1 style="font-size: 24px; color: black;">默认分类管理</h1>
        <el-card class="form-container" shadow="never">
            <el-button class="sub-sub" type="primary" @click="showDetails('新增分类')">新增</el-button>
        </el-card>
        <el-tabs type="border-card" v-model="isExpenseFlag"  @tab-click="changeIndex" >
             
             <el-tab-pane label="收入" name="false"></el-tab-pane>
             <el-tab-pane label="支出" name="true"></el-tab-pane>
        <h1>
            <el-table :data="datas"
                      border
                      :fit="true">
                <el-table-column label="id" prop="id" width="50px" align="center"></el-table-column>
                <el-table-column label="名称" prop="name" width="200px" align="center"></el-table-column>
                <el-table-column  label="图片" width="200px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="收支类型"  prop="isExpense"  width="50px"  >
                    <template slot-scope="scope">
                        {{ scope.row.isExpense ?  '支出': '收入' }}
                    </template>
                </el-table-column>
                <el-table-column label="排序" prop="rank" width="50px" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="showDetails('编辑应用',scope.row)">编辑</el-button>
                        <!-- <el-button type="danger" size="small" @click="remove(scope.row.id)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>

        </el-tabs>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="coverForm">
                <el-form-item label="名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="coverForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="图片 :" :label-width="labelWidth">
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadImage">
                        <img v-if="coverForm.image" :src="VUE_APP_CDN_URL+coverForm.image" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="收支类型:" :label-width="labelWidth" >
                    <el-radio-group style="width: 300px" v-model="coverForm.isExpense">
                            <el-radio :label="true">支出</el-radio>
                            <el-radio :label="false">收入</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="位置:" :label-width="labelWidth" >
                    <el-input-number v-model="coverForm.rank"  :min="-200" ></el-input-number>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        upload
    } from "@/http/iosApi";
    import {
        saveCategory,
        // deleteCover,
        searchCategory
    } from "@/http/iosBookApi";
    export default {
        name: "BookUserCategory",
        data(){
            return{
                VUE_APP_IOS_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                dialogVisible:false,
                dialogTitle:'',
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                datas:[],
                labelWidth: '110px',
                labelWidth2: '200px',
                coverForm: {
                    id: null,
                    name: '',
                    image:'',
                    rank:1,
                    isExpense:false
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null,
                    isExpense:false
                },
                isExpenseFlag:"false"
            }
        },
        methods:{
            showDetails(title,data){
                if (data){
                    this.coverForm= {
                        id: data.id,
                        name: data.name,
                        image: data.image,
                        rank: data.rank,
                        isExpense:data.isExpense
                    }
                }else {
                    this.coverForm= {
                        id: null,
                        name: '',
                        image:'',
                        rank:1,
                        isExpense:null
                    }
                }
                this.dialogTitle  = title;
                this.dialogVisible = true;
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            handleImageSuccess(response){
                this.coverForm.image=response.info;
            },
            // remove(id){
            //     this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
            //         cancelButtonClass: 'btn-custom-cancel',
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         deleteCover(id).then(resp=> {
            //             if (resp.data.status === 0) {
            //                 this.search();
            //             }
            //         });
            //     }).catch(() => {
            //     })
            // },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过10MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            confirmForm(){
                let _message = '';
                if(this.coverForm.name===''){
                    _message = '请输入名称'
                }else if (this.coverForm.image===''){
                    _message = '请上传图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveCategory(this.coverForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            search(){
                searchCategory(this.page).then(resp=>{
                    this.datas = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            changeIndex: function(tab){
                console.log(tab)
                // this.isExpenseFlag  = tab.name;
                this.page.isExpense= tab.name;
                this.page.page = 1;
                this.search();
            },
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
        },
        mounted() {
            this.VUE_APP_IOS_URL=process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
